import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BRAND, APP_TITLE } from "./branding";
import { API, clearCache } from "./cache";
import "./AppSidebar.css";

// ── Icons ─────────────────────────────────────────────────────────────────────

const IcoDashboard = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
);
const IcoTasks = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
  </svg>
);
const IcoEpic = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2.4 4.8 5.3.8-3.8 3.7.9 5.2-4.8-2.5-4.8 2.5.9-5.2L4.3 7.6l5.3-.8L12 2z" />
  </svg>
);
const IcoNetwork = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);
const IcoLayers = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2"/>
    <polyline points="2 17 12 22 22 17"/>
    <polyline points="2 12 12 17 22 12"/>
  </svg>
);
const IcoClock = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IcoUsers = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IcoBug = () => (
  <svg viewBox="4 1.5 16 18" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="13" rx="4" ry="5.5"/>
    <circle cx="12" cy="6.5" r="2"/>
    <line x1="10.5" y1="5" x2="8" y2="2.5"/>
    <line x1="13.5" y1="5" x2="16" y2="2.5"/>
    <circle cx="8" cy="2.5" r="0.5" fill="currentColor" stroke="none"/>
    <circle cx="16" cy="2.5" r="0.5" fill="currentColor" stroke="none"/>
    <line x1="8" y1="10" x2="5" y2="8.5"/>
    <line x1="16" y1="10" x2="19" y2="8.5"/>
    <line x1="8" y1="13" x2="5" y2="13"/>
    <line x1="16" y1="13" x2="19" y2="13"/>
    <line x1="8" y1="16" x2="5" y2="17.5"/>
    <line x1="16" y1="16" x2="19" y2="17.5"/>
    <line x1="12" y1="8" x2="12" y2="18.5"/>
  </svg>
);
const IcoFolder = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  </svg>
);
const IcoUser = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);
const IcoChart = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
    <line x1="2" y1="20" x2="22" y2="20"/>
  </svg>
);
const IcoTodo = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="1"/>
    <line x1="9" y1="9" x2="15" y2="9"/>
    <line x1="9" y1="12" x2="15" y2="12"/>
    <line x1="9" y1="15" x2="12" y2="15"/>
    <polyline points="6 9 7 10 6 11"/>
  </svg>
);
const IcoRocket = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
    <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
  </svg>
);
const IcoRetro = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    {/* Ascending bars — filled */}
    <rect fill="currentColor" stroke="none" x="5.5" y="15" width="3" height="3.5"/>
    <rect fill="currentColor" stroke="none" x="10" y="11" width="3.5" height="7.5"/>
    <rect fill="currentColor" stroke="none" x="15.5" y="7.5" width="3" height="11"/>
    {/* Top arc: 200° → 340° clockwise through top, r=9.5 */}
    <path d="M 3.1 8.75 A 9.5 9.5 0 0 1 20.9 8.75"/>
    <polyline points="18.8 7.4 20.9 8.75 21.6 6.4"/>
    {/* Bottom arc: 20° → 160° clockwise through bottom, r=9.5 */}
    <path d="M 20.9 15.25 A 9.5 9.5 0 0 1 3.1 15.25"/>
    <polyline points="5.2 16.6 3.1 15.25 2.4 17.6"/>
  </svg>
);
const IcoPresales = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
  </svg>
);
const IcoCopilot = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z"/>
    <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z"/>
  </svg>
);
const IcoShield = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IcoSliders = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="6" x2="20" y2="6"/>
    <line x1="4" y1="12" x2="20" y2="12"/>
    <line x1="4" y1="18" x2="20" y2="18"/>
    <circle cx="8" cy="6" r="2" fill="currentColor" stroke="none"/>
    <circle cx="16" cy="12" r="2" fill="currentColor" stroke="none"/>
    <circle cx="10" cy="18" r="2" fill="currentColor" stroke="none"/>
  </svg>
);
const IcoCog = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);
const IcoToggle = ({ collapsed }) => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {collapsed
      ? <><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></>
      : <><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></>
    }
  </svg>
);

// ── Nav config ─────────────────────────────────────────────────────────────────

const WORKSPACE = [
  { path: "/dashboard",    label: "Dashboard",    Icon: IcoDashboard },
  { path: "/masterv2",     label: "Tasks",        Icon: IcoTasks,   badge: true },
  { path: "/epics",        label: "Epics",        Icon: IcoEpic },
  { path: "/dependencies", label: "Dependencies", Icon: IcoNetwork },
  { path: "/timesheet",    label: "Timesheet",    Icon: IcoClock },
  { path: "/meetingsv2",   label: "Meetings",     Icon: IcoUsers },
  { path: "/defectsv2",    label: "Defects",      Icon: IcoBug },
  { path: "/todo",         label: "ToDo",         Icon: IcoTodo },
  { path: "/releases",     label: "Releases",     Icon: IcoRocket },
  { path: "/retrov2new",   label: "Retro",        Icon: IcoRetro },
  { path: "/presales",     label: "Pre-Sales",    Icon: IcoPresales, superAdminOnly: true },
  { path: "/copilot",      label: "AI Copilot",   Icon: IcoCopilot,  superAdminOnly: true },
];
const EXTERNAL_WORKSPACE_PATHS = new Set(["/masterv2", "/dependencies", "/defectsv2", "/releases"]);

const ADMIN_MENU = [
  { path: "/features",       label: "Features",       desc: "Product features & roadmap",   Icon: IcoLayers  },
  { path: "/projects",       label: "Projects",       desc: "Customers, projects & teams",  Icon: IcoFolder  },
  { path: "/reports",        label: "Reports",        desc: "Analytics & exports",           Icon: IcoChart   },
  { path: "/users",          label: "Users",          desc: "Team members & roles",          Icon: IcoUser,   adminOnly: true },
  { path: "/settings",       label: "Settings",       desc: "App & workspace settings",      Icon: IcoSliders, adminOnly: true },
];

const ADMIN_PATHS = new Set(ADMIN_MENU.map(i => i.path));

// ── Helpers ───────────────────────────────────────────────────────────────────

function initials(name) {
  if (!name) return "?";
  return name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
}

function isAdmin(user) {
  const role = String(user?.db_role || "").trim().toLowerCase();
  return (role === "admin" || role === "super admin") && user?.db_user_type === "Internal";
}

function isSuperAdmin(user) {
  return user?.db_role === "Super Admin" && user?.db_user_type === "Internal";
}

function isExternal(user) {
  const t = String(user?.db_user_type || "").toLowerCase();
  return t === "external" || t === "external user";
}

// ── Component ─────────────────────────────────────────────────────────────────

export default function AppSidebar({ user, collapsed, onCollapse, taskCount = 0 }) {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [menuOpen,   setMenuOpen]   = useState(false);
  const [adminOpen,  setAdminOpen]  = useState(false);
  const [flyoutPos,  setFlyoutPos]  = useState(null);
  const menuRef    = useRef(null);
  const adminBtnRef = useRef(null);
  const flyoutRef  = useRef(null);

  // Close avatar menu on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (!menuRef.current || menuRef.current.contains(e.target)) return;
      setMenuOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  // Close admin flyout on outside click
  useEffect(() => {
    if (!adminOpen) return;
    const onDocClick = (e) => {
      if (adminBtnRef.current?.contains(e.target)) return;
      if (flyoutRef.current?.contains(e.target)) return;
      setAdminOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [adminOpen]);

  // Close admin flyout on route change
  useEffect(() => { setAdminOpen(false); }, [location.pathname]);

  // Clamp flyout so it never overflows the bottom of the viewport
  useEffect(() => {
    if (!adminOpen || !flyoutRef.current) return;
    const el = flyoutRef.current;
    const rect = el.getBoundingClientRect();
    if (rect.bottom > window.innerHeight - 8) {
      setFlyoutPos(prev => prev && ({
        ...prev,
        top: Math.max(8, window.innerHeight - rect.height - 8),
      }));
    }
  }, [adminOpen]);

  const handleLogout = async () => {
    let logoutUrl = null;
    try {
      const r = await fetch(`${API}/logout`, { method: "POST", credentials: "include" });
      const data = await r.json().catch(() => ({}));
      logoutUrl = data?.logout_url || null;
    } catch {
      // Proceed with local cleanup even if backend logout fails.
    }
    clearCache();
    // Full-page navigation to Microsoft's end-session endpoint so the AAD
    // SSO session is cleared too — otherwise clicking Login again silently
    // re-authenticates with no prompt (see App.jsx's handleLogout).
    window.location.assign(logoutUrl || "/");
  };

  const toggleAdminMenu = () => {
    if (adminOpen) { setAdminOpen(false); return; }
    const sb = adminBtnRef.current?.closest(".app-sb");
    const sbRect = sb?.getBoundingClientRect();
    const btnRect = adminBtnRef.current?.getBoundingClientRect();
    if (!sbRect || !btnRect) return;
    setFlyoutPos({ top: btnRect.top, left: sbRect.right + 6 });
    setAdminOpen(true);
  };

  const external = isExternal(user);
  const visibleWorkspace = external
    ? WORKSPACE.filter(({ path }) => EXTERNAL_WORKSPACE_PATHS.has(path))
    : WORKSPACE.filter(({ adminOnly, superAdminOnly }) =>
        (!adminOnly && !superAdminOnly) || (adminOnly && isAdmin(user)) || (superAdminOnly && isSuperAdmin(user)));
  const visibleAdmin = external
    ? []
    : ADMIN_MENU.filter(({ adminOnly }) => !adminOnly || isAdmin(user));
  const isAdminActive = ADMIN_PATHS.has(location.pathname);

  return (
    <aside className={`app-sb${collapsed ? " app-sb--collapsed" : ""}`}>

      {/* Logo */}
      <div className="app-sb-logo">
        <a href="index.html" title={APP_TITLE}>
          {BRAND.logoUrl
            ? <img src={BRAND.logoUrl} alt={BRAND.orgName || BRAND.productName} />
            : <span className="app-sb-logo-badge">{(BRAND.orgName || BRAND.productName).slice(0, 2).toUpperCase()}</span>}
        </a>
        {!collapsed && <span className="app-sb-logo-name">{BRAND.productName}</span>}
        <button
          className="app-sb-toggle"
          onClick={onCollapse}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <IcoToggle collapsed={collapsed} />
        </button>
      </div>

      {/* Workspace */}
      <div className="app-sb-section">Workspace</div>
      {visibleWorkspace.map(({ path, label, Icon, badge }) => (
        <button
          key={path}
          className={`app-sb-item${location.pathname === path ? " app-sb-item--active" : ""}`}
          onClick={() => navigate(path)}
          data-tooltip={collapsed ? label : undefined}
          aria-label={collapsed ? label : undefined}
          title={collapsed ? label : undefined}
        >
          <Icon />
          <span>{label}</span>
          {badge && taskCount > 0 && <span className="app-sb-badge">{taskCount}</span>}
        </button>
      ))}

      {/* Admin */}
      {visibleAdmin.length > 0 && (
        <>
          <div className="app-sb-section">Admin</div>
          <button
            ref={adminBtnRef}
            className={`app-sb-item${isAdminActive || adminOpen ? " app-sb-item--active" : ""}`}
            onClick={toggleAdminMenu}
            data-tooltip={collapsed ? "Admin" : undefined}
            aria-label={collapsed ? "Admin" : undefined}
            title={collapsed ? "Admin" : undefined}
          >
            <IcoCog />
            <span>Admin</span>
            {!collapsed && (
              <svg
                viewBox="0 0 10 6" width="9" height="9"
                fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
                style={{ marginLeft: "auto", transform: adminOpen ? "rotate(180deg)" : "none", transition: "transform 0.15s" }}
              >
                <polyline points="1 1 5 5 9 1"/>
              </svg>
            )}
          </button>
        </>
      )}

      <div className="app-sb-spacer" />

      {/* Footer */}
      <div className="app-sb-footer" ref={menuRef}>
        <button
          className="app-sb-avatar"
          onClick={() => setMenuOpen((v) => !v)}
          title="Profile actions"
          aria-label="Profile actions"
        >
          {initials(user?.name || user?.email)}
        </button>
        {!collapsed && (
          <div className="app-sb-user-info">
            <div className="app-sb-user-name">{user?.name || "User"}</div>
            <div className="app-sb-user-role">{user?.db_role || "—"}</div>
          </div>
        )}
        {menuOpen && (
          <div className="app-sb-avatar-menu">
            <button className="app-sb-avatar-menu-item" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>

      {/* Admin flyout panel */}
      {adminOpen && flyoutPos && (
        <div
          ref={flyoutRef}
          className="app-sb-admin-flyout"
          style={{ top: flyoutPos.top, left: flyoutPos.left }}
        >
          <div className="app-sb-admin-flyout-title">Admin</div>
          {visibleAdmin.map(({ path, label, desc, Icon }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                className={`app-sb-admin-item${active ? " app-sb-admin-item--active" : ""}`}
                onClick={() => { navigate(path); setAdminOpen(false); }}
              >
                <span className={`app-sb-admin-ico${active ? " app-sb-admin-ico--active" : ""}`}>
                  <Icon />
                </span>
                <span className="app-sb-admin-text">
                  <span className="app-sb-admin-label">{label}</span>
                  <span className="app-sb-admin-desc">{desc}</span>
                </span>
              </button>
            );
          })}
        </div>
      )}

    </aside>
  );
}

// Sidebar width constants — used by parent layouts for grid-template-columns
export const SB_W  = "212px";
export const SB_W_COLLAPSED = "56px";
